module.exports = __webpack_public_path__ + "static/media/13_death.c571f4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/13_death.png
// module id = 76
// module chunks = 0